import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../../ui/button';

export type GenericType = {
  type: 'manufacturer' | 'status' | 'availability' | 'supplier';
  type2: 'manufacturers' | 'statuses' | 'availabilities' | 'suppliers';
};

export function AttributeGeneric({ type, type2 }: GenericType) {
  const { t } = useTranslations();
  const data = useCategoryStore(state => state.category[type2]);
  const filter = useCategoryStore(state => state.filter[type2]);
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(data ?? [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

  return (
    <div className={cn('flex flex-wrap gap-2', 'ea-attribute-generic')}>
      {data?.length ? (
        sortedValues.map(value => (
          <Button
            key={`attribute-${type}-value-${value.id}`}
            variant={filter.includes(value.id) ? 'default' : 'primary-foreground'}
            onClick={() => setFilter({ [type]: value.id })}
            className={cn('ea-attribute-generic__button')}
          >
            {value.name}
          </Button>
        ))
      ) : (
        <p className={cn('text-sm', 'ea-attribute-generic__no-attribute-text')}>{t('text445')}.</p>
      )}
    </div>
  );
}
